import { action, success, failure, request } from 'app/actions';

export const CHECK_COORDINATOR_PERMISSION_EVALUATION =
  'simulated/edition/CHECK_COORDINATOR_PERMISSION_EVALUATION';
export const checkCoordinatorPermissionEvaluation = (payload) =>
  action(CHECK_COORDINATOR_PERMISSION_EVALUATION, { payload });

export const DOWNLOAD_PDF = 'simulated/edition/DOWNLOAD_PDF';
export const downloadPdf = (payload) => action(DOWNLOAD_PDF, { payload });

export const GENERATE_EVALUATION_ANSWER_SHEET_FILES =
  'simulated/edition/GENERATE_EVALUATION_ANSWER_SHEET_FILES';
export const generateEvaluationAnswerSheetsFiles = (payload) =>
  action(GENERATE_EVALUATION_ANSWER_SHEET_FILES, { payload });

export const GENERATE_EVALUATION_ANSWER_SHEET_FILES_STATUS =
  'simulated/edition/GENERATE_EVALUATION_ANSWER_SHEET_FILES_STATUS';
export const generateEvaluationAnswerSheetsFilesStatus = (payload) =>
  action(GENERATE_EVALUATION_ANSWER_SHEET_FILES_STATUS, { payload });

export const GET_EVALUATION_ONLINE_IN_PROGRESS =
  'simulated/edition/GET_EVALUATION_ONLINE_IN_PROGRESS';
export const getEvaluationOnlineInProgress = (payload) =>
  action(GET_EVALUATION_ONLINE_IN_PROGRESS, { payload });

export const LOG_DOWNLOAD_ESSAY_GUIDELINES =
  'simulated/edition/LOG_DOWNLOAD_ESSAY_GUIDELINES';
export const logDownloadEssayGuidelines = (payload) =>
  action(LOG_DOWNLOAD_ESSAY_GUIDELINES, { payload });
